import { connect } from 'react-redux'

import {
  filterType,
  filterBedrooms,
  filterBudget,
  showAllFilters,
} from '../redux/modules/search/actions'

import ManageGuestDetailsFilterButtons from '../components/ManageGuestDetailsFilterButtons'

const mapStateToProps = (state) => ({
  downloadAllKeyinstructionsLink: state.search.downloadAllKeyInstructionsLink,
  manageGuestDetailsLink: state.search.manageGuestDetailsLink

})

const actionsCreators = {
  showAllFilters,
}

export default connect(mapStateToProps, actionsCreators)(ManageGuestDetailsFilterButtons)



// WEBPACK FOOTER //
// ./src/containers/ManageGuestDetailsFilterButtons.js